export class ConsolidationRuleDefinitionDTO{
    public id!: number;
    public name!: string;
    public description!: string;
    public ruleType!: string;
    public inputDataType!: string;
    public parameterCount!: number;
    public parameterLabels!: string;
}